import React from 'react';
import { CardsContainer } from './styled';
import { CardsLayoutProps } from './types';

export const CardsLayout: React.FC<CardsLayoutProps> = ({
  children,
  hasHorizontalScroll = false,
  forwardedRef,
  countOfVisibleMobileCards,
  countOfVisibleTabletCards
}) => {
  const refList = forwardedRef || null;
  return (
    <CardsContainer
      ref={refList}
      $hasHorizontalScroll={hasHorizontalScroll}
      $countOfVisibleMobileCards={countOfVisibleMobileCards}
      $countOfVisibleTabletCards={countOfVisibleTabletCards}
    >
      {children}
    </CardsContainer>
  );
};
